/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'scripts';

export const controlScriptModalBreadcrumbTitle = `${prefix}.controlScriptModalBreadcrumbTitle`;
export const protocolParserScriptModalBreadcrumbTitle = `${prefix}.protocolParserScriptModalBreadcrumbTitle`;

export const ENGLISH = {
    [controlScriptModalBreadcrumbTitle]: 'Control Script',
    [protocolParserScriptModalBreadcrumbTitle]: 'Protocol Parser Script',
};
